import React from 'react';
import PropTypes from 'prop-types';

import styles from './NotificationsLink.css';

export const NotificationsCount = ({ count }) => {
  const notificationCount = `You have ${count} notification${count === 1 ? '' : 's'}`;

  return count ? (
    <span aria-label={notificationCount} className={styles.notificationsLinkCount}>
      {count}
    </span>
  ) : null;
};

NotificationsCount.propTypes = {
  count: PropTypes.number
};

NotificationsCount.defaultProps = {
  count: 0
};
